import React from 'react';
import { Award } from 'lucide-react';
import { Achievement } from '../../types';
import ShareButton from '../social/ShareButton';

interface AchievementCardProps {
  achievement: Achievement;
  isNew?: boolean;
}

const AchievementCard: React.FC<AchievementCardProps> = ({ achievement, isNew }) => {
  return (
    <div className={`relative bg-white rounded-lg shadow-md p-4 border ${
      isNew ? 'border-blue-500' : 'border-gray-200'
    }`}>
      {isNew && (
        <div className="absolute -top-2 -right-2 bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded-full">
          New!
        </div>
      )}
      
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0">
          <img referrerPolicy="no-referrer" src={achievement.icon} alt={achievement.name} className="h-8 w-8" />
        </div>
        
        <div>
          <h3 className="font-semibold text-gray-900">{achievement.name}</h3>
          <p className="text-sm text-gray-600">{achievement.description}</p>
        </div>
      </div>
      <div className="ml-auto">
        <ShareButton achievement={achievement} isNew={isNew} />
      </div>
    </div>
  );
};

export default AchievementCard;